export const fetchOnlineReviewActionType = {
  START_FETCHING_ONLINE_REVIEW_DATA: 'START_FETCHING_ONLINE_REVIEW_DATA',
  SUCCESS_FETCHING_ONLINE_REVIEW_DATA: 'SUCCESS_FETCHING_ONLINE_REVIEW_DATA',
  FAILURE_FETCHING_ONLINE_REVIEW_DATA: 'FAILURE_FETCHING_ONLINE_REVIEW_DATA',
  CLEAR_ONLINE_REVIEW_DATA: 'CLEAR_ONLINE_REVIEW_DATA'
};

export const FETCH_ONLINE_REVIEW_DATA_PAGE_TYPE = 'medallia';
export const FETCH_ONLINE_REVIEW_DATA_CAMPAIGN = 'online_review_page_test';
export const FETCH_OVERVIEW_ONLINE_REVIEW_BY_PROPERTIES_DATA_CAMPAIGN = "online_reviews_by_property"
export const FETCH_OVERVIEW_ONLINE_REVIEW_PROPERTIES_DRILL_DOWN_DATA_CAMPAIGN = "online_reviews_property_drilldown"
